<div class="modal-header">
  <h4 class="modal-title">{{ step.title }}</h4>
  <button
    type="button"
    class="close"
    aria-label="Close"
    (click)="complete()"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <p class="onboarding-progress text-muted">
    Step {{ currentStep + 1 }} of {{ steps.length }}
  </p>
  <p>{{ step.description }}</p>
  <button
    *ngIf="step.actionRoute"
    type="button"
    class="btn btn-primary"
    (click)="goTo(step.actionRoute)"
  >
    {{ step.actionLabel }}
  </button>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-link mr-auto" (click)="complete()">
    Skip
  </button>
  <button
    *ngIf="currentStep > 0"
    type="button"
    class="btn btn-secondary"
    (click)="back()"
  >
    Back
  </button>
  <button
    *ngIf="!isLastStep"
    type="button"
    class="btn btn-primary"
    (click)="next()"
  >
    Next
  </button>
  <button
    *ngIf="isLastStep"
    type="button"
    class="btn btn-primary"
    (click)="complete()"
  >
    Finish
  </button>
</div>
